import { Colors } from '../constants/Colors'

export default {
    colors: Colors
}
